<template>
          <v-dialog v-model="show" max-width="580" :fullscreen="$vuetify.breakpoint.xs" scrollable >
            <v-card>
                <v-card-title class="headline primary--text fixNotchPaddingTop rundown-dialog-head">
                {{$t('HISTORY_TITLE')}}
                </v-card-title>

                <v-card-text>

                <v-row v-if="loading" cols="12" justify="center"  min-height="400">
                    <v-col class="mx-auto" cols="12">
                        <v-skeleton-loader type="table-tbody" class="mx-auto" max-width="90%"/>
                    </v-col>
                </v-row>

                <v-row v-if="!loading && (!items || items.length==0)" cols="12" justify="center">
                    <v-col class="mx-auto" cols="12" min-height="400" style="text-align:center;">
                            <v-icon style="font-size:6em;" color="grey lighten-1" >mdi-history </v-icon> 
                            <p style="font-size:1.2em;" color="grey lighten-2">{{$t("HISTORY_NO_DATA")}}</p>
                    </v-col>
                </v-row>

                <v-list three-line  flat v-if="!loading  && items && items.length>0" min-height="400">
                <v-list-item-group
                    v-model="selected" 
                    active-class="primary--text"
                >
                    <template v-for="(item, index) in items">
                    <v-list-item :key="item.id" style="padding: 0px; cursor:auto; cursor:pointer;" @click="loadItem(item)"> 
                        <template v-slot:default="{  }"> 
                        <v-list-item-content>
                            <v-list-item-title class="primary--text" v-text="item.title"></v-list-item-title>
                            <v-list-item-subtitle class="text--blue-grey lighten-4"  v-text="formatLocalDateTime(item.creationDate)"></v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-icon
                            v-if="isOwner()" v-on:click.stop="doDelete(item, index)" 
                            color="grey lighten-1"
                            >
                            mdi-delete
                            </v-icon> 
                        </v-list-item-action>
                        </template>
                    </v-list-item>

                    <v-divider
                        v-if="index + 1 < items.length"
                        :key="item.id + '-sep'"
                    ></v-divider>
                    </template>
                </v-list-item-group>
                </v-list>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="fixNotchPaddingBottom">
                <v-spacer></v-spacer>
              <v-btn color="primary rundown-dialog-btn" text @click="close()">{{$t('HISTORY_CLOSE')}}</v-btn> 
             </v-card-actions>
      </v-card>


      <v-snackbar
        style="z-index:100002"
        v-model="snackbar"
        :top="true"
        class="fixNotchMarginTop"
        :timeout="2000"
        color="warning"
      >
        {{$t('HISTORY_PREMIUM_WARN')}}
        <template v-slot:action="{ attrs }">
          <v-btn color="black" text v-bind="attrs" @click="snackbar = false">{{$t('HISTORY_CLOSE')}}</v-btn>
        </template>
      </v-snackbar>
    </v-dialog>
</template>

<script>
 import BaseModule from './BaseModule' 
  export default {
    name: 'RundownHistoryDialog', 
    mixins: [BaseModule],
    props: [],
    data(){
        return {  
             snackbar: false,
             show: false,
             loading: false,
             adminPreview: false,
             user: {
                 id: null
             },
             rundown: {
                 announcementChecked: null,
                 userId: null,
                 parentId: null
             },
              selected: [],
                items: [],
        }

    },  
    methods: {
        close()
        {
            this.show=false
            window.rundownApp.device.backButtonCallback = null;
        },
        doDelete(item, index)
        {

            window.genericConfirm( 
                   this.$t('HISTORY_DELETE_TITLE'), this.$t('HISTORY_DELETE_MESAGE'), this.$t('HISTORY_DELETE_OK'), this.$t('HISTORY_DELETE_CANCEL'),
                    () => {
                    this.items.splice(index,1);
                    this.loading=true;
                    // eslint-disable-next-line no-unused-vars
                    window.rundownApp.api.deleteHistoryItem(item.id, (res) => {
                            this.loading=false;
                    });
            });
           
            
        }, 
        isOwner()
        {
            return !this.rundown.parentId && !this.adminPreview;
        }, 
        loadItem(item) {

            if (window.isPremium()===false)
            {
                this.snackbar=true;
                return;
            }

            this.loading=true;
            window.rundownApp.api.getRundownHistory(item.id, (historyItem)=> {
                var _fileManager = window.rundownApp.fileManager.getInstance(); 
                _fileManager.BroadcastRundownHistory(historyItem);
                this.loading=false;
                this.close();
            },
            (error) => 
            {
                window.vueapp.showToast(error);
                console.log(error);
                this.loading=false;
            });
             
            
        }, 
        showHistory(user,rundown)
        {  
            this.show=true;
            console.log(rundown);
            this.loading=true;
            this.rundown=rundown;
            this.user=user;
            this.item=[];

            window.rundownApp.device.backButtonCallback = this.close;

            this.adminPreview = window.rundownApp.user && rundown.userId != window.rundownApp.user.id
      

            const me = this;
             window.rundownApp.api.getRundownHistoryList(rundown.rundownId,
            function(res){
                    me.loading=false;
                    me.items = res; 
            }
            ,function(error){
                    me.loading=false; 
                    console.log(error); 
            });
        } 
      },
  }
</script>